import { useNavigate } from '@tanstack/react-router';
import { useEffect, type ReactNode } from 'react';

import { KYC_REQUIRED_EVENT, type KycStatusEnvelope } from '../api/client.ts';

interface KycRequiredEventDetail {
  readonly kycStatus: KycStatusEnvelope;
}

// Listens for the api-client's KYC_REQUIRED event and routes the user
// to /kyc-pending carrying the kycStatus search param. Mounted at the
// root so any guarded fetch's 403 + KYC_REQUIRED — regardless of which
// route originated it — surfaces the per-status splash. Headless
// component: renders nothing.
export const KycRequiredRedirect = (): ReactNode => {
  const navigate = useNavigate();
  useEffect(() => {
    const onKycRequired = (event: Event): void => {
      const detail = (event as CustomEvent<KycRequiredEventDetail>).detail;
      void navigate({
        to: '/kyc-pending',
        search: { status: detail.kycStatus },
      });
    };
    window.addEventListener(KYC_REQUIRED_EVENT, onKycRequired);
    return (): void => {
      window.removeEventListener(KYC_REQUIRED_EVENT, onKycRequired);
    };
  }, [navigate]);
  return null;
};
